import { gql } from '@apollo/client';

// Re-export queries from the main location-applications queries file
// This prevents breaking other imports while maintaining a single source of truth
export {
  UPDATE_LOCATION_SELECTED_IT_APPS,
} from '../../queries';

export const GET_LOCATION_IT_APPS_MATRIX = gql`
  query GetLocationItApllicationsDashboard($data: ID!) {
    getLocationItApllicationsDashboard(data: $data) {
      divisions {
        applications {
          name
          supportsRevenue
          uuid
          value {
            percentage
            revenue
          }
          description
        }
        name
        productGroups {
          applications {
            name
            supportsRevenue
            uuid
            value {
              percentage
              revenue
            }
          }
          name
          products {
            applications {
              name
              supportsRevenue
              uuid
              value {
                percentage
                revenue
              }
            }
            name
            revenue
            uuid
          }
          revenue
          uuid
        }
        revenue
        uuid
      }
    }
  }
`;

export const SET_LOCATION_IT_APP_DEPENDENCY_PERCENTAGE = gql`
  mutation SetLocationDependencyPercentage(
    $data: SetLocationDependencyDataInput!
  ) {
    setLocationDependencyPercentage(data: $data)
  }
`;

export const GET_LOCATION_IT_APPS_SUMMARY = gql`
  query GetLocationItApplicationsSummary($data: ID!) {
    getLocationItApplicationsSummary(data: $data) {
      applicationDescription
      name
      percentageOfCompanySupported
      revenueSupportedAnnualy
      uuid
    }
  }
`;

export const UPDATE_LOCATION_IT_APPS = gql`
  mutation SelectLocationItApplications(
    $data: SelectLocationsItApplicationsInput!
  ) {
    selectLocationItApplications(data: $data)
  }
`;
